import axios, {AxiosResponse} from 'axios'
const api = '/api/'
// Get all roles
const getRoles = async ({params}) => {
  const response = await axios.get(`${api}role/list`, params)
  return response.data
}

const getSystems = async () => {
  const response = await axios.get(`${api}role/get-systems`)
  return response.data
}

// edit role
const EditRole = async (roleId: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}role/edit/${roleId}`)
  return response.data
}

// Get permissions
const getPermissions = async (system_id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}role/get-permissions/${system_id}`)
  return response.data
}

// Create role
const createRole = async ({data}) => {
  await axios.post(`${api}role/store`, data)
}

// Delete role
const deleteRole = async (role_id: string) => {
  await axios.post(`${api}role/destroy/${role_id}`)
}

const roleService = {
  getRoles,
  getSystems,
  EditRole,
  getPermissions,
  createRole,
  deleteRole,
}

export default roleService
